import {
    apiRequest,
    angkaKreditDetail,
    angkaKreditUpdate,
} from "../../../../../services/adapters/kepegawaian/pengajuanAngkaKreditService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", angkaKreditDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", angkaKreditUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository